module.exports = __webpack_public_path__ + "img/zhangpin.66bc2f0d.jpg";